<template>
<ac-modal :title="'Update Unique IDs for ' + companyName" :size-class="'modal-md'" ref="uniqueIdUpdater">
    <div class="row">
        <div class="col-md-12 form-group">
            <div class="alert alert-warning">This will permenantly update the member's unique ID for a group.</div>
            <p class="form-group">
                Upload an Excel template with new member unique IDs,
                the tool will match members using their date of birth and last name and then update their unique ID.
            <p>
            <label class="company-label">
                Select An Excel File
            </label>
            <div class="input-group" id="csv-selector-container">
                <label class="input-group-btn">
                    <span class="btn btn-blue btn-sm btn-file" style="border-top-width: 4px; border-bottom-width: 3px"
                        title="Click to select an Excel file from your computer to upload.">
                        Browse&hellip; <input ref="uploader" type="file" style="display: none;" @change="fileSelected">
                    </span>
                </label>
                <input type="text" class="form-control col-8" readonly v-model="fileName">
            </div>
        </div>
        <div class="col-md-12">
            <ac-button type="button" class="btn btn-green btn-sm pull-right"
                    title="Click to upload the file previously selected using the 'Browse' button."
                    :action="uploadFile">
                <i class="fa fa-lg fa-download"></i> UPDATE UNIQUE IDS
            </ac-button>
            <ac-button type="button" style="margin-right: 10px" class="btn btn-red btn-sm pull-right"
                    title="Click to remove the file previously selected using the 'Browse' button."
                    :action="closeModal">
                CANCEL
            </ac-button>
        </div>
    </div>
</ac-modal>
</template>

<script>
import {notifications} from "../../../../global/notifications.js";
import {common} from "../../../../global/common.js";
import {api} from "../../../../global/framework/api.js";

export default {
    data() {
        return {
            companyId: null,
            companyName: "Group",
            spreadsheet: null,
            fileName: "",
        }
    },
    methods: {
        async showModal(data) {
            if (!data.companyId) throw "Company Id is required";
            this.companyId = data.companyId;
            if (data.companyName) this.companyName = data.companyName;
            this.$refs.uniqueIdUpdater.open();
        },
        closeModal() {
            this.clearFile();
            this.$refs.uniqueIdUpdater.close();
        },
        async uploadFile() {
            if (this.spreadsheet == null) {
                notifications.show({
                    title: "Error",
                    message: "You need to select a file first"
                }, common.ACRESSA_NOTIFICATIONS.ERROR);
                return;
            } 
            
            let formData = new FormData();
            formData.append("employeeCsv", this.spreadsheet);

            let result = await $.ajax({
                type: "POST",
                url: `Admin/${this.companyId}/UpdateMemberUniqueIds`,
                contentType: false,
                processData: false,
                data: formData
            });

            if (result) {
                notifications.show({
                    title: "Success!", 
                    message: result.msg
                }, common.ACRESSA_NOTIFICATIONS.SUCCESS);

                this.clearFile();
                this.closeModal();
            }
        },
        clearFile() {
            this.spreadsheet = null;
            this.fileName = "";
            this.$refs.uploader.value = null;
        },
        fileSelected(event) {
            this.spreadsheet = null;
            let fileData = event.target.files[0];

            if (fileData) {
                this.spreadsheet = fileData;
                this.fileName = fileData.name;
                let fileExt = this.fileName.substring(this.fileName.lastIndexOf('.'));

                if (fileExt !== '.xlsx') {
                    notifications.show({
                        title: "Error",
                        message: "Only xlsx files types are allowed."
                    }, common.ACRESSA_NOTIFICATIONS.ERROR);
                    this.clearFile();
                }
            }
        },
    },
}
</script>
